import { cn } from '@workspace/lib';
import { ContentCarouselMediaRenderer } from './ContentCarouselMedia';
import { VIDEO_DIMENSIONS, IMAGE_DIMENSIONS } from '@workspace/constants';
import { CarouselSlide } from '../content-carousel.types';

interface ContentCarouselDesktopMediaProps {
  slides: CarouselSlide[];
  currentIndex: number;
  isImageRight: boolean;
  isCurrentVideo: boolean;
  slideWrapperClass: string;
}

export function ContentCarouselDesktopMedia({
  slides,
  currentIndex,
  isImageRight,
  isCurrentVideo,
  slideWrapperClass,
}: ContentCarouselDesktopMediaProps) {
  return (
    <div
      className={cn(
        'md:flex items-center justify-center w-full hidden',
        'aspect-video overflow-hidden',
        slideWrapperClass,
        isImageRight ? 'md:order-3' : 'order-1',
        isCurrentVideo ? 'md:max-w-148.75' : 'md:max-w-136',
      )}
    >
      <div className="relative w-full h-full">
        {slides?.map((slide) => (
          <ContentCarouselMediaRenderer
            key={slide._key}
            slide={slide}
            isActive={slide._key === slides[currentIndex]?._key}
            imageDimensions={IMAGE_DIMENSIONS}
            videoDimensions={VIDEO_DIMENSIONS}
          />
        ))}
      </div>
    </div>
  );
}
